import { styled } from "@mui/material/styles";
import IconButton, { IconButtonProps } from "@mui/material/IconButton";

type ButtonPosition = string;

interface StyledIconButtonProps extends IconButtonProps {
  position?: ButtonPosition;
}

export const StyledIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "position", // prevent position leaking into DOM
})<StyledIconButtonProps>(({ theme, position = "left" }) => ({
  position: "absolute",
  top: "40%",
  zIndex: 1,
  backgroundColor: "#ffffff",
  boxShadow: theme.shadows[5],
  height:'40px',
  width:'40px',
  borderRadius: '80px',
  "&:hover": {
    backgroundColor: "#ffffff",
  },
  "&:disabled": {
    backgroundColor: "rgba(0, 0, 0, 0.12)",
  },
  ...(position === "left" && { left: 0 }),
  ...(position === "right" && { right: 0 }),
}));